import { render, staticRenderFns } from "./select-group-company.vue?vue&type=template&id=28de53dc"
import script from "./select-group-company.vue?vue&type=script&lang=ts"
export * from "./select-group-company.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports